import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/about/business/pageContext';

export const BusinessErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for About/Business page (error: ${error})`);
};
